'use client';

import { styled } from '../../../styles';

export const CoinCellContainer = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3),
}));

export const CoinCellNameContainer = styled.div(() => ({
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));
